"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatRiotGlyphs = formatRiotGlyphs;
const icon_packs_1 = __importDefault(require("./src/icon-packs"));
const get_image_url_1 = __importDefault(require("./src/utils/get-image-url"));
function formatRiotGlyphs(inputString, options) {
    const { formatter } = options || {};
    const glyphRegex = /:([a-zA-Z0-9-_.]+):/g;
    return inputString.replace(glyphRegex, (matchedString, glyphName) => {
        var _a;
        for (const pack of icon_packs_1.default) {
            if (glyphName.startsWith(pack.prefix)) {
                const iconKey = glyphName.slice(pack.prefix.length);
                const image = pack.icons[iconKey];
                if (!image)
                    return matchedString;
                const imageUrl = (0, get_image_url_1.default)({
                    cdnSuffix: pack.cdnSuffix,
                    image,
                    version: pack.version,
                });
                return (_a = formatter === null || formatter === void 0 ? void 0 : formatter({ matchedString, imageUrl })) !== null && _a !== void 0 ? _a : `<img src="${imageUrl}" />`;
            }
        }
        return matchedString;
    });
}
